import { apiClient } from './setupApi';

const bonuses = '/bonuses';

export const requestGetCompany = async () => {
  const { data } = await apiClient.get(`${bonuses}/company`);
  return data;
};

export const requestCreateCompany = async (name) => {
  const { data } = await apiClient.post(`${bonuses}/company`, name);
  return data;
};

export const requestDeleteCompany = async (id) => {
  const { data } = await apiClient.delete(`${bonuses}/company/${id}`);
  return data;
};

export const requestCreateService = async (payload) => {
  const data = await apiClient.post(`${bonuses}/company/service`, payload);

  return data;
};

export const requestDeleteService = async (id) => {
  const { data } = await apiClient.delete(`${bonuses}/company/service/${id}`);
  return data;
};

export const requestGetBranches = async (update) => {
  const data = await apiClient.get(`${bonuses}/city`, {
    params: {
      ...update
    }
  });
  return data;
};

export const requestPostCreateEvent = async (payload) => {
  const data = await apiClient.post(`${bonuses}/card`, payload);
  return data;
};

export const requestGetEventById = async (id) => {
  const { data } = await apiClient.get(`${bonuses}/card/${id}`);
  return data;
};

export const requestGetBonusRecordById = async (id) => {
  const { data } = await apiClient.get(`${bonuses}/transactions/${id}`);
  return data;
};

export const requestGetBonusRecordHistoryById = async (id) => {
  const { data } = await apiClient.get(`${bonuses}/transactions/${id}/history`);
  return data;
};

export const requestGetBonusRecordXmlById = async (id) => {
  const { data } = await apiClient.get(`${bonuses}/transactions/${id}/xml`, { responseType: 'text' });
  return data;
};

export const requestUpdateEvent = async (id, payload) => {
  const data = await apiClient.patch(`${bonuses}/card/${id}`, payload);
  return data;
};

export const requestGetEvents = async (payload) => {
  const { data } = await apiClient.get(`${bonuses}/card`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestGetBonusRecords = async (payload) => {
  const { data } = await apiClient.get(`${bonuses}/transactions`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestGetPackages = async (update) => {
  const data = await apiClient.get(`${bonuses}/packages`, {
    params: {
      ...update
    }
  });
  return data;
};

export const requestUploadFiles = async (payload) => {
  const { data } = await apiClient.post(`${bonuses}/card/file`, payload);
  return data;
};

export const requestUploadFilesForCard = async (payload, id) => {
  const { data } = await apiClient.post(`${bonuses}/card/${id}/file`, payload);
  return data;
};

export const requestDeleteFiles = async (id, file_id) => {
  return await apiClient.delete(`${bonuses}/card/${id}/file/${file_id}`);
};

export const requestGetTriggers = async () => {
  const { data } = await apiClient.get(`${bonuses}/trigger`);
  return data;
};

export const requestSetArchviedCard = async (id, payload) => {
  const { data } = await apiClient.patch(`${bonuses}/card/${id}/status`, payload);
  return data;
};

export const requestGetCmsPackages = async (payload) => {
  return await apiClient.get(`${bonuses}/packages/cms`, {
    params: {
      ...payload
    }
  });
};

export const requestGetCopyBonusCard = async (id) => {
  const { data } = await apiClient.get(`${bonuses}/card/${id}/copy`);
  return data;
};

export const requestGetDistributions = async () => {
  const { data } = await apiClient.get(`${bonuses}/mailing`);
  return data;
};

export const requestGetSubscribersFile = async (id, payload) => {
  const { data } = await apiClient.get(`${bonuses}/card/${id}/files`, {
    params: {
      ...payload
    }
  });
  return data;
};

export const requestSendOnApprove = async (id) => {
  const { data } = await apiClient.post(`${bonuses}/card/${id}/approve`, {
    status: 'На одобрении'
  });
  return data;
};

export const requestApproveOrDeny = async (id, payload) => {
  const { data } = await apiClient.patch(`${bonuses}/card/${id}/approve`, payload);
  return data;
};

const cms = '/v1/cms-loyalty/api/bonuses';

export const requestGetBonusesPackages = async (payload) => {
  const { data } = await apiClient.get(`${cms}/packages`, {
    params: {
      ...payload
    }
  });
  return data;
};
export const requestGetBonusPackage = async (payload) => {
  const { data } = await apiClient.get(`${cms}/packages/${payload}`);
  return data;
};

export const requestPostBonusesPackages = async (payload) => {
  const { data } = await apiClient.post(`${cms}/packages`, payload);
  return data;
};

export const requestPatchBonusesPackage = async (id, payload) => {
  const { data } = await apiClient.patch(`${cms}/packages/${id}`, payload);
  return data;
};

export const requestPatchBonusesPackageStatus = async (id, payload) => {
  const { data } = await apiClient.patch(`${cms}/packages/${id}/status`, payload);
  return data;
};

export const requestDeleteBonusesPackage = async (id) => {
  const { data } = await apiClient.delete(`${cms}/packages/${id}`);
  return data;
};

export const requestPostUploadPackageImage = async (payload) => {
  const { data } = await apiClient.post(`${cms}/packages/upload`, payload);
  return data;
};
